import { render, staticRenderFns } from "./NIHSSSelect.vue?vue&type=template&id=0a67f46e&"
import script from "./NIHSSSelect.vue?vue&type=script&lang=ts&"
export * from "./NIHSSSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a67f46e')) {
      api.createRecord('0a67f46e', component.options)
    } else {
      api.reload('0a67f46e', component.options)
    }
    module.hot.accept("./NIHSSSelect.vue?vue&type=template&id=0a67f46e&", function () {
      api.rerender('0a67f46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/v2/NIHSSSelect.vue"
export default component.exports